"use strict";
var fieldBildnrCtrl = function($scope, $attrs, $parse) {
  var init = function() {
    var name = $parse($attrs.name)($scope);
    $scope.name = name;
    $scope.entries = $scope.data[name].entries;
    $scope.schema = $scope.data[name].schema;
  };
  $scope.addEntry = function() {
    $scope.entries.push({value: ""});
  };
  $scope.removeEntry = function(entry) {
    if ($scope.entries.length > 1) {
      var index = $scope.entries.indexOf(entry);
      $scope.entries.splice(index, 1);
    }
  };
  init();
};
fieldCtrl.$inject = ['$scope', '$attrs', '$parse'];
module.exports = fieldCtrl;
